import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

export interface BasePageContainerProps {
    children: ReactNode
    title?: string
    subtitle?: string
    headerAction?: ReactNode
}

export const BaseHeader = ({ title, subtitle, headerAction }: Omit<BasePageContainerProps, 'children'>) => {
    if (!title) return null

    return (
        <Box sx={{ width: '100%', mb: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Box>
                    <Typography variant="h3" fontWeight="bold" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography sx={{ color: 'rgba(255,255,255,0.7)', mt: 1 }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                {headerAction && (
                    <Box sx={{ ml: 2 }}>
                        {headerAction}
                    </Box>
                )}
            </Box>
        </Box>
    )
} 